import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Injectable} from "@angular/core";
import {CommonService} from "../../../shared/services/common.service";
import {lastValueFrom, Observable} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../state/app.state";
import {HttpClient} from "@angular/common/http";
import {v1URL} from "../../../shared/constants/urls.constants";
import {drillDownUrls} from "../../../shared/core/shared.selectors";
import {SetDrillDownUrls} from "../../../shared/core/shared.actions";

@Injectable({
  providedIn: 'root'
})
export class ClientGuard {
  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
    private http?: HttpClient,
  ) {
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree> {
    const {clientId} = route.params;

    let response: any = {
      data: false
    }

    if (clientId) {
      this.commonService.startLoading();

      const url = v1URL.canIAccess.clientDetails.url(Number(clientId));
      const method = v1URL.canIAccess.clientDetails.method;

      try {
        response = await lastValueFrom(this.http[method](url));
      } catch (e) {
        response = e;
      }

      this.commonService.handleResourceAccessResponse(response, 'clientId', clientId);

      this.commonService.stopLoading();
    } else {
      this.commonService.requestedGroupId.next(null);
    }

    return response.data;
  }
}
